import { INIT_LOGGED_IN, SET_LOADER_ON, SET_LOADER_OFF } from "../Actions/actionTypes";

const INITIAL_STATE = {
  isLoggedIn: false,
  loaderOn: false,
  userForEdit: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INIT_LOGGED_IN:
      return { ...state, isLoggedIn: true };
    case SET_LOADER_ON:
      return { ...state, loaderOn: true };
    case SET_LOADER_OFF:
      return { ...state, loaderOn: false };

    default:
      return { ...state };
  }
};
